import { FC } from 'react'
import * as cn from 'classnames'
import * as isNumber from 'lodash/isNumber'
import * as styles from 'styles/unorganized/SavingsMonthly.css'
import { formatUSCurrency } from 'helpers/formatHelpers'
import AbsentValue from 'components/atoms/AbsentValue'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { OPPORTUNITIES_PAGE } from 'constants/pages'

export type SavingsMonthlyProps = {
  savingsAmount: number | null
  onClick?: () => void
}

const createLinkWrapper = (onClick: () => void): FC => ({ children }) => (
  <NavigationLink to={ OPPORTUNITIES_PAGE } onClick={ onClick }>{ children }</NavigationLink>
)

const StaticWrapper: FC = ({ children }) => (
  <>{ children }</>
)

const SavingsMonthly: FC<SavingsMonthlyProps> = (props) => {
  const { savingsAmount, onClick } = props

  const savingsAmountExists = isNumber(savingsAmount)
  const isClickable = Boolean(onClick && savingsAmountExists)

  const Wrapper: FC = isClickable && onClick ? createLinkWrapper(onClick) : StaticWrapper

  const wrapperChildren = savingsAmount !== null ? (
    <div className={ cn(styles.savingMonthly, { [styles.clickable]: isClickable }) }>
      { formatUSCurrency(savingsAmount) }/month
    </div>
  ) : (
    <AbsentValue>N/A</AbsentValue>
  )

  return (
    <Wrapper>{ wrapperChildren }</Wrapper>
  )
}

export default SavingsMonthly
